import { Buffer } from 'buffer';
import process from 'process/browser';

const globalScope = globalThis as any;

globalScope.global ??= globalScope;
globalScope.process ??= process;
globalScope.Buffer ??= Buffer;
